import { useRef, useState } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import Logo from "../assets/ops-banner.svg";
import { CircleX, Download, PrinterIcon } from "lucide-react";

export default function OfferLetterModal({ data, onClose }) {
  const pdfRef = useRef();
  const [loading, setLoading] = useState(false);
  // DOWNLOAD PDF
  const downloadPDF = async () => {
    setLoading(true);

    const pages = pdfRef.current.querySelectorAll(".pdf-page");
    const pdf = new jsPDF("p", "mm", "a4");

    await new Promise((resolve) => setTimeout(resolve, 300));

    for (let i = 0; i < pages.length; i++) {
      const canvas = await html2canvas(pages[i], {
        scale: 2,
        useCORS: true,
        backgroundColor: "#ffffff",
      });

      const img = canvas.toDataURL("image/png");

      const width = pdf.internal.pageSize.getWidth();
      const height = (canvas.height * width) / canvas.width;

      if (i !== 0) pdf.addPage();

      pdf.addImage(img, "PNG", 0, 0, width, height);
    }

    pdf.save("offer-letter.pdf");
    setLoading(false);
  };
  // PRINT
  const printPDF = async () => {
    setLoading(true);

    const pages = pdfRef?.current?.querySelectorAll(".pdf-page");
    if (!pages || pages.length === 0) return;

    const pdf = new jsPDF("p", "mm", "a4");

    await new Promise((resolve) => setTimeout(resolve, 300));

    for (let i = 0; i < pages.length; i++) {
      const canvas = await html2canvas(pages[i], {
        scale: 2,
        useCORS: true,
        backgroundColor: "#ffffff",
      });

      const img = canvas.toDataURL("image/png");

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

      if (i !== 0) pdf.addPage();

      pdf.addImage(img, "PNG", 0, 0, pdfWidth, pdfHeight);
    }

    const blobURL = pdf.output("bloburl");

    const printWindow = window.open(blobURL, "_blank");

    if (printWindow) {
      printWindow.onload = () => {
        printWindow.focus();
        printWindow.print();
        setLoading(false);
      };
    } else {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50">
      <div className="bg-white w-[1000px] max-h-[95vh] overflow-auto rounded-xl shadow-lg">
        {/* HEADER */}
        <div className="flex justify-between items-center p-4 border-b">
          <h2 className="font-semibold text-lg">Offer Letter Preview</h2>

          <div className="flex gap-3">
            <button
              onClick={printPDF}
              className="bg-sky-600 hover:bg-sky-700 text-white px-4 py-2 rounded"
            >
              <PrinterIcon size={20} color="white" />
            </button>

            <button
              onClick={downloadPDF}
              className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded"
            >
              <Download size={20} color="white" />
            </button>

            <button
              onClick={onClose}
              className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded"
            >
              <CircleX />
            </button>
          </div>
        </div>
        {loading && (
          <div className="absolute inset-0 bg-white/70 flex items-center justify-center z-50">
            <div className="flex flex-col items-center gap-3">
              <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
              <p className="text-sm font-medium">Generating PDF...</p>
            </div>
          </div>
        )}

        {/* PDF PAGES */}
        <div
          ref={pdfRef}
          className="flex flex-col items-center gap-6 p-6 bg-gray-200"
        >
          <Page1 data={data} />
          <Page2 data={data} />
          <Page3 data={data} />
          <Page4 data={data} />
          <Page13 data={data} />
          <Page5 data={data} />
          <Page6 />
          <Page7 />
          <Page8 />
          <Page9 data={data} />
          <Page10 />
          <Page11 data={{ data }} />
          <Page12 data={{ data }} />
        </div>
      </div>
    </div>
  );
}

/* ---------- A4 WRAPPER ---------- */
function Footer() {
  return (
    <div className="border-t px-12 py-6 text-[12px] text-gray-700 flex justify-between items-center">
      {/* LEFT SIDE */}
      <div className="max-w-[60%] leading-5">
        {/* <p className="font-semibold">Odisha Parcel Service Limited</p> */}
        <p>Registered Office: PLOT NO-701/5403, LANE-1, PATITAPABANA NAGAR,</p>
        <p>Badagarh Brit Colony, Bhubaneswar, Khorda-751018, Orissa</p>
      </div>

      {/* VERTICAL LINE */}
      <div className="border-l h-16 mx-6"></div>

      {/* RIGHT SIDE */}
      <div className="leading-5 text-right">
        <p>CIN: U53200OD2024PTC047585</p>
        {/* <p>+91 124 6225600</p> */}
        <p>customersupport@odishaparcel.com</p>
        <p>www.odishaparcel.com</p>
      </div>
    </div>
  );
}
function PageWrapper({ children }) {
  return (
    <div
      className="bg-white pdf-page mx-auto relative flex flex-col "
      style={{
        width: "794px",
        minHeight: "1123px",
        // fontFamily: "Times New Roman, serif",
        // fontFamily: "Inter, sans-serif",
      }}
    >
      <div className="flex items-center gap-3 px-12 pt-10 ">
        <div>
          <img src={Logo} alt="logo" className="" />
        </div>
        {/* <div className=" text-3xl font-bold absolute top-10 left-28">
          Odisha Parcel Service
        </div> */}
      </div>

      {/* PAGE CONTENT */}
      <div className="flex-1 px-12 pt-10">{children}</div>

      {/* FOOTER */}
      <Footer />
    </div>
  );
}

/* ---------- PAGE 1 ---------- */

function Page1({ data }) {
  return (
    <PageWrapper>
      <p>
        <b>Ref No:</b> {data.refNo}
      </p>

      <p>
        <b>Date:</b> {data.date}
      </p>

      <p className="mt-6 font-semibold">{data.name}</p>

      <p>{data.address}</p>

      {/* GREETING */}
      <p className="mt-6">Dear {data.name},</p>

      {/* INTRO PARAGRAPH */}
      <p className="text-justify mb-6">
        Further to your recent meetings and discussions with us, we are pleased
        to offer you employment with <b>Odisha Parcel Service</b> in the
        position of <b> {data.position}</b> at the Company's office located at
        <b> {data.location}</b>, on the terms and conditions set out
        hereinafter:
      </p>

      {/* EMPLOYMENT */}
      <div className="mb-6">
        <h2 className="font-bold uppercase">EMPLOYMENT</h2>

        <p className="">
          <b>
            Your effective date of joining shall be no later than{" "}
            {data.joiningDate}.
          </b>
        </p>

        <p className="text-justify mb-6">
          Your employment with the Company shall be subject to successful
          pre-and/or post-employment background checks, the accuracy of the
          testimonials and information provided by you and your being free from
          any contractual restrictions preventing you from accepting this offer
          or starting work with us on the above-mentioned date. You, if so asked
          by the Company, shall disclose on your own behalf and, if married, on
          your spouse's behalf full details of any external directorships held
          and any personal business interests including partnerships,
          shareholdings and trusteeships; involvement in any other business
          ventures involving unlimited liability; personal liabilities in
          connection with business activities; and involvement in other
          positions external to the Company and acceptance by the Company of
          those external interests. Please note that if during the pre or
          post-employment background checks, the background checking agency
          gives a negative report or in the event of unsatisfactory result of
          your pre or post-employment background checks, this letter of
          appointment shall stand revoked automatically (whether you have
          accepted it or not) and, if you have already commenced employment with
          the Company, such employment shall automatically terminate without
          giving rise to any claim for compensation or damages in your favor,
          but without prejudice to Company's rights and remedies against you.
        </p>
      </div>

      {/* PLACE OF POSTING */}
      <div className="mb-10">
        <h2 className="font-bold uppercase">PLACE OF POSTING</h2>

        <p className="text-justify">
          Your initial place of posting shall be at the Company’s office located
          at <b>{data.location}</b>.
        </p>
      </div>
    </PageWrapper>
  );
}

/* ---------- PAGE 2 ---------- */

function Page2({ data }) {
  return (
    <PageWrapper>
      <div className="leading-7 text-justify">
        However, your services are transferable and you may be assigned /
        transferred in India or outside India to serve the Company in any of its
        existing or future offices or any of its group companies or associates.
        It is a condition of your employment that you comply with any such
        requirements of the Company. The transfer arrangement shall not deem to
        constitute a change in your conditions of service. Notwithstanding the
        above, you may however be required to work at any other place that the
        Company may deem fit and as may be required from time to time. You may
        also be seconded, deputed or transferred to any other person / company
        associated with the Company whether in India or abroad. In such a case
        your relocation expenses shall be borne by the Company and your
        reimbursement shall be as per the Relocation Policy of the Company.
        Parts of the Company operate on a 24X7 basis and are open for 365 days
        in a year.
      </div>
      <h3 className="font-bold pt-6">PERFORMANCE OF DUTIES</h3>

      <p className=" leading-7 text-justify">
        You shall be assigned all the duties and responsibilities of the{" "}
        <b>{data?.position}</b> and such other duties on behalf of the Company,
        as may be resonably assigned from time to time by the Company's
        management.
      </p>

      <h3 className="font-bold mt-6">PROBATION</h3>

      <p className="leading-7 text-justify">
        You shall serve a minimum probation period of 6 (Six) months from the
        date of your joining the Company (“Probation”) following which your
        employment with the Company shall be deemed to be confirmed, unless
        stated otherwise, and in writing. The Company reserves the right to
        extend the Probation period for an additional period, as deemed
        appropriate, in the event of your performance being dis-satisfactory. It
        shall be your responsibility to read, pursue and follow Company’s
        regulations/policies, copies whereof shall be made available to you on
        the HRMS portal.
        <br /> During the period of Probation, either the Company or you may at
        any time terminate this letter of appointment, without cause, by giving
        in writing to the other party, 15 (Fifteen) days notice or in lieu
        thereof a sum equal to the amount or pro-rated amount of basic salary
        which would have accrued to you during the period or remaining period of
        notice.
      </p>
    </PageWrapper>
  );
}

/* ---------- PAGE 3 ---------- */

function Page3({ data }) {
  return (
    <PageWrapper>
      <div>
        You shall not be entitled to any notice pay if your employment is
        terminated in accordance with Appendix 3 to this letter of appointment.
      </div>
      <h3 className="font-bold mt-6">COMPENSATION</h3>

      <p className=" text-justify">
        As compensation for services to be rendered, you shall be paid an annual
        fixed salary of Rs. <b>{data?.ctc}</b>. Your cost to the company (CTC)
        shall be Rs.
        <b>{data?.ctc}</b> per annum. Adetailed compensation structure is
        provided along with this letter of appointment (Appendix 1). The salary
        shall be payable on a monthly basis in arrears on or about the last
        working day of each calendar month, but in no case later than the 10th
        day of the succeeding calendar month. Please note that your salary
        details are highly confidential and should not be disclosed inside or
        outside the Company by you in any manner whatsoever and any failure on
        your part to adhere to this obligation shall be considered as serious
        breach of the terms of this letter of appointment. You shall keep
        strictly confidential, details of your salary and the employment
        benefits provided to you, within and outside the Company.
      </p>
      <h3 className="font-bold pt-6">RELOCATION</h3>

      <p className="leading-7">
        Any Relocation assistance, if provided shall be as per the Company's
        relocation policy.
      </p>
      <h3 className="font-bold mt-6">TERMINATION OF EMPLOYMENT </h3>
      <p className="leading-7 text-justify">
        During Probation period, either the Company or you may at any time
        terminate this letter of appointment without cause by giving in writing
        to the other party, 15 (Fifteen) day's notice. You shall not be entitled
        to any notice pay if your employment is terminated in accordance with
        Appendix 3 to this letter of appointment.
        <br /> After completion of the Probation period, either Company or you
        may at any time terminate this letter of appointment without cause by
        giving in writing to the other party, 30 (Thirty) day's notice. The
        Company reserves the right either to accept your pay and allowance /
        towards the notice period or demand for actual service during the notice
        period. You shall not be entitled to any notice pay if your employment
        is terminated in accordance with Appendix 3 to this letter of
        appointment.
      </p>
      {/* <p className="mt-10">For Odisha Parcel Service</p>

      <p className="mt-6 font-bold">{data.hrName}</p>

      <p>{data.hrDesignation}</p> */}
    </PageWrapper>
  );
}
function Page4({ data }) {
  return (
    <PageWrapper>
      <p className="leading-7 text-justify">
        <br /> Your employment shall also be governed by the standard terms and
        conditions, which are annexed hereto as Appendix 3 and the same shall
        form an integral part of this letter of appointment. Your employment is
        conditional upon your acceptance of the standard terms and conditions
        and the specific provisions contained in Appendix 3.
        <br /> Kindly sign and return the duplicate copy of this letter of
        appointment along with the Appendixes, as a token of your acceptance of
        the terms and conditions set out herein. Also, please initial each page
        of this letter of appointment and the Appendixes. Please note that by
        signing this letter of appointment, you have agreed to accept the
        employment with the Company on the terms and conditions set out herein.
        Upon your signature and return to us, this letter of appointment shall
        be treated as an employment agreement and the terms and conditions of
        this letter of appointment shall govern your employment with the
        Company. This letter of appointment shall automatically stand revoked in
        the event you do not join the Company on or before the effective date
        mentioned in this letter of appointment.
        <br />
        It is a pleasure to welcome you as a part of Odisha Percel Service
        Limited. On your first day of employment, please report to our office
        located at Bhubaneshwar, at 9.30 AM along with the documents as
        mentioned in the Appendix2.
      </p>
    </PageWrapper>
  );
}
function Page5({ data }) {
  return (
    <PageWrapper>
      <h3 className="font-bold mb-6">Appendix 1 : Salary Breakup</h3>

      <table className="w-full border border-black text-sm border-collapse">
        <thead>
          <tr className="bg-gray-100 font-semibold">
            <th className="border border-black p-2 text-left">Components</th>
            <th className="border border-black p-2 text-right">Per Annum</th>
            <th className="border border-black p-2 text-right">Per Month</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td className="border border-black p-2">Basic</td>
            <td className="border border-black p-2 text-right">
              {data.basicAnnual}
            </td>
            <td className="border border-black p-2 text-right">
              {data.basicMonthly}
            </td>
          </tr>

          <tr>
            <td className="border border-black p-2">HRA</td>
            <td className="border border-black p-2 text-right">
              {data.hraAnnual}
            </td>
            <td className="border border-black p-2 text-right">
              {data.hraMonthly}
            </td>
          </tr>

          <tr>
            <td className="border border-black p-2">Bonus</td>
            <td className="border border-black p-2 text-right">
              {data.bonusAnnual}
            </td>
            <td className="border border-black p-2 text-right">
              {data.bonusMonthly}
            </td>
          </tr>

          <tr>
            <td className="border border-black p-2">Special Allowance</td>
            <td className="border border-black p-2 text-right">
              {data.specialAllowanceAnnual}
            </td>
            <td className="border border-black p-2 text-right">
              {data.specialAllowanceMonthly}
            </td>
          </tr>

          <tr className="font-bold">
            <td className="border border-black p-2">Gross</td>
            <td className="border border-black p-2 text-right">
              {data.grossAnnual}
            </td>
            <td className="border border-black p-2 text-right">
              {data.grossMonthly}
            </td>
          </tr>

          {/* Deductions */}
          <tr>
            <td
              colSpan="3"
              className="border border-black p-2 font-semibold bg-gray-100"
            >
              Deductions
            </td>
          </tr>

          <tr>
            <td className="border border-black p-2">Employee PF</td>
            <td className="border border-black p-2 text-right">
              {data.employeePFAnnual}
            </td>
            <td className="border border-black p-2 text-right">
              {data.employeePFMonthly}
            </td>
          </tr>

          <tr>
            <td className="border border-black p-2">Employee ESI</td>
            <td className="border border-black p-2 text-right">
              {data.employeeESIAnnual}
            </td>
            <td className="border border-black p-2 text-right">
              {data.employeeESIMonthly}
            </td>
          </tr>

          <tr>
            <td className="border border-black p-2">PT</td>
            <td className="border border-black p-2 text-right">
              {data.ptAnnual}
            </td>
            <td className="border border-black p-2 text-right">
              {data.ptMonthly}
            </td>
          </tr>

          <tr className="font-bold">
            <td className="border border-black p-2">Total Deductions</td>
            <td className="border border-black p-2 text-right">
              {data.totalDeductionsAnnual}
            </td>
            <td className="border border-black p-2 text-right">
              {data.totalDeductionsMonthly}
            </td>
          </tr>

          <tr>
            <td className="border border-black p-2">Net Pay Before Tax</td>
            <td className="border border-black p-2 text-right">
              {data.netPayAnnual}
            </td>
            <td className="border border-black p-2 text-right">
              {data.netPayMonthly}
            </td>
          </tr>

          {/* Company Contribution */}
          <tr>
            <td
              colSpan="3"
              className="border border-black p-2 font-semibold bg-gray-100"
            >
              Company Contribution
            </td>
          </tr>

          <tr>
            <td className="border border-black p-2">Employer PF</td>
            <td className="border border-black p-2 text-right">
              {data.employerPFAnnual}
            </td>
            <td className="border border-black p-2 text-right">
              {data.employerPFMonthly}
            </td>
          </tr>

          <tr>
            <td className="border border-black p-2">Employer ESIC</td>
            <td className="border border-black p-2 text-right">
              {data.employerESICAnnual}
            </td>
            <td className="border border-black p-2 text-right">
              {data.employerESICMonthly}
            </td>
          </tr>

          <tr className="font-bold">
            <td className="border border-black p-2">Sub Total</td>
            <td className="border border-black p-2 text-right">
              {data.subTotalAnnual}
            </td>
            <td className="border border-black p-2 text-right">
              {data.subTotalMonthly}
            </td>
          </tr>

          <tr className="font-bold">
            <td className="border border-black p-2">CTC</td>
            <td className="border border-black p-2 text-right">
              {data.ctcAnnual}
            </td>
            <td className="border border-black p-2 text-right">
              {data.ctcMonthly}
            </td>
          </tr>

          <tr className="font-bold">
            <td className="border border-black p-2">Total CTC</td>
            <td className="border border-black p-2 text-right">
              {data.ctcAnnual}
            </td>
            <td className="border border-black p-2"></td>
          </tr>
        </tbody>
      </table>
    </PageWrapper>
  );
}
function Page6() {
  return (
    <PageWrapper>
      <div className="mb-6 leading-7">
        <b>Notes:</b> Taxes shall be deducted subject to Investments declared to
        the organization has been computed on a yearly basis. Taxes will be
        computed as per the government regulations, which can change from time
        to time.
      </div>
      <h3 className="font-bold mb-6">Appendix 2</h3>

      <h3 className="font-semibold">
        Please come prepared with the following documents on your day of
        Joining:
      </h3>

      <ol className="mt-4 space-y-2 list-decimal ml-6">
        <li>Highest Qualification Proof(Mark sheet and Certificate/Degree)</li>
        <li>PAN Card</li>
        <li>Aadhar Card</li>
        <li>Permanent Address Proof(Aadhaar card/Voter ID Card/Passport)</li>
        <li>Current Address Proof</li>
        <li>Relieving Letter from Previous Employer</li>
        <li>Passport Size Photograph</li>
        <li>Latest Salary Slip</li>
        <li>Bank Statement / Cancelled Cheque</li>
        <li>Signed Offer Letter</li>
      </ol>

      <div className="leading-7 text-justify mt-6">
        Your employment with the Company shall be subject to submission of the
        above documents and required joining forms on the date of joining. Shall
        you fail to submit the same even within 7 (seven) days of your joining,
        the Company reserves the right to terminate your employment, in the
        event the above documents and forms are not submitted within the time
        stated above.
      </div>
    </PageWrapper>
  );
}
function Page7() {
  return (
    <PageWrapper>
      <h3 className="font-bold mb-6">Appendix 3</h3>
      <div className="font-bold underline">
        STANDARD TERMS AND CONDITIONS OF EMPLOYMENT
      </div>
      <div className="leading-7 text-justify">
        This appendix containing the Standard Terms and Conditions of employment
        is attached to the letter of appointment and shall be deemed to be an
        integral part thereof. Your employment is conditional upon your
        acceptance of the standard terms and conditions detailed herein.
      </div>
      <div className="font-bold mt-6">1.BENEFITS</div>
      <h3 className="leading-7 text-justify">
        You will also be entitled, during the term of your employment, to such
        leaves, medical Insurance, Group Personal Accident and other employee
        benefits as the Company may offer from time to time, subject to
        applicable eligibility requirements. The Company does reserve the right
        to make any modifications in this benefits package that it deems
        appropriate. A brief overview of benefits currently being offered
      </h3>

      <ul className="list-disc pl-6 space-y-1 mt-6">
        <li>
          Eligibility for a total of 32 days of Annual leaves every financial
          year (April-March)
        </li>
        <li>Gratuity shall be paid as per the Gratuity Act</li>
        <li>
          Eligibility for Provident fund as per the Employees Provident Fund and
          Miscellaneous Provisions Act, 1952
        </li>
        <li>
          Eligible for Employees State Insurance as per the Employees State
          Insurance Act, 1948
        </li>
        <li>
          Performance Linked Incentives shall be paid based on performance
          during the financial year.
        </li>
        <li>
          Please refer to the respective policy documents, as updated and
          available on the Company’s HRMS portal for details.
        </li>
      </ul>
    </PageWrapper>
  );
}
function Page8() {
  return (
    <PageWrapper>
      <h3 className="font-bold">2.CONFIDENTIALITY</h3>
      <p>
        In consideration of the Company furnishing You with the Confidential
        Information, the employee agree as follows:
      </p>

      <ul>
        <li className="mt-5 text-justify">
          1. The Confidential Information shall be used by You solely within the
          scope of your engagement of services for which the disclosure was
          made, and not for any other purpose. You shall not disclose
          Confidential Information to any third party and shall otherwise treat
          such Confidential Information as you treat like information of your
          own. You agree shall always take whatever commercially reasonable
          steps are necessary to protect the confidentiality of such
          information.
        </li>

        <li className="mt-5 text-justify">
          2. You are required to keep the Confidential Information confidential
          as you would your own confidential information and trade secrets and
          keep in confidence and subject to the terms and conditions of this
          Agreement. You shall not disclose the Confidential Information or any
          part thereof to any Person. You shall not take any copies or make any
          summaries or transcripts or reproduce or transmit by any means and in
          any form whatsoever (including in an externally accessible computer or
          electronic information retrieval system) of the whole or any part of
          the Confidential Information otherwise than as required in pursuance
          to this Agreement and without the prior written consent of the
          Company.
        </li>

        <li className="mt-5 text-justify">
          3. The term "Confidential Information" shall be deemed not to include
          information which is or becomes generally available to the public
          other than as a result of a disclosure by You or any other person who
          directly or indirectly receives such information from You or in
          violation of a confidentiality obligation to the Company known to You
          or is or becomes available to You on a non-confidential basis from a
          source which is entitled to disclose it to You.
        </li>

        <li className="mt-5 text-justify">
          4. Unless otherwise specified in a separate agreement between the
          parties, all Confidential Information disclosed by the Company to You
          shall be and shall remain the Company’s property. Upon termination of
          your engagement of services for which the disclosure was made, or at
          any time upon Company’s request, you shall promptly return all
          existing tangible Confidential Information to the Company. Any type of
          Confidential Information tangible and intangible that you came across
          during the tenure with the organization, that shall remain subject to
          the confidentiality obligations post the termination as per this
          Agreement.
        </li>

        {/* <li className="mt-6 text-justify">
          6. Intellectual Property Ownership. The Employee hereby assigns to the
          Company all rights, including, without limitation, copyrights,
          patents, trade secret rights, and other intellectual property rights
          associated with any ideas, concepts, techniques, inventions,
          processes, works of authorship, Confidential Information or trade
        </li> */}
      </ul>
    </PageWrapper>
  );
}
function Page9() {
  return (
    <PageWrapper>
      <div className="mt-5 text-justify mb-6">
        5. In case of breach of the terms and conditions of this Agreement or
        any unauthorized disclosure or use of the confidential Information by
        you, which may cause the Company irreparable harm, sufficient injury,
        loss and damage, the extent of which may be impossible to ascertain and
        which cannot be fully compensated by monetary damages, in addition to
        any other remedies the Company may have at law or in equity, the Company
        shall be entitled to seek immediate injunction and other equitable
        relief against you to prevent any further or continuing breach of your
        obligations. In addition to all remedies available in law and equity,
        you will also be liable to pay for all legal fees and costs incurred in
        the successful enforcement of this Agreement or the successful
        establishment of breach of this Agreement.
      </div>
      <div className=" leading-7 text-justify">
        6. Intellectual Property Ownership. The Employee hereby assigns to the
        Company all rights, including, without limitation, copyrights, patents,
        trade secret rights, and other intellectual property rights associated
        with any ideas, concepts, techniques, inventions, processes, works of
        authorship, Confidential Information or trade secrets (i) developed or
        created by the Employee, solely or jointly with others, during the
        course of performing work for or on behalf of the Company or any
        affiliate of the Company, or the predecessors of any such entities,
        whether as an employee or independent contractor, (ii) that the Employee
        conceives, develops, discovers or makes in whole or in part during the
        Employee’s employment by the Company that relate to the business of the
        Company or any affiliate of the Company or the actual or demonstrably
        anticipated research or development of the Company or any affiliate of
        the Company, (iii) that the Employee conceives, develops, discovers or
        makes in whole or in part during or after the Employee’s employment by
        the Company that are made through the use of any of the equipment,
        facilities, supplies, trade secrets or time of the Company or any
        affiliate of the Company, or that result from any work the Employee
        performs for the Company or any affiliate of the Company, or (iv)
        developed or created by the Employee, solely or jointly with others, at
        any time before the Employment Period, that relate to or involve the
        Company’s businesses (including, but not limited to, the business of the
        Company Group) (collectively, the “Work Product”).
      </div>
    </PageWrapper>
  );
}
function Page10({ data }) {
  return (
    <PageWrapper>
      <div className="leading-7 text-justify">
        Without limiting the foregoing, to the extent possible, all software,
        compilations and other original works of authorship included in the Work
        Product will be considered a “work made for hire” as that term is
        defined in Title 17 of the United States Code. If, notwithstanding the
        foregoing, the Employee for any reason retains any right, title or
        interest in or relating to any Work Product, the Employee agrees
        promptly to assign, in writing and without any requirement of further
        consideration, all such right, title, and interest to the Company. Upon
        request of the Company at any time during or after the Employment
        Period, the Employee will take such further actions, including execution
        and delivery of instruments of conveyance, as may be appropriate to
        evidence, perfect, record or otherwise give full and proper effect to
        any assignments of rights under or pursuant to this Agreement. The
        Employee will promptly disclose to the Company any such Work Product in
        writing.
      </div>
      <h3 className="font-bold pt-6">3. DISCIPLINARY ACTION PROCEDURE </h3>
      <div className="text-justify leading-7">
        Any breach of the Company's regulations/policies, failure to attain or
        maintain a satisfactory work standard or any misconduct by an employee
        shall be regarded as a disciplinary or capability matter. Your immediate
        superior shall normally deal with minor disciplinary matters. The
        procedure for more serious offences including major misconduct shall be
        dealt in the manner set out under the Company's regulations/policies.
        Further, in case of any kind of mis-conduct, the Company is at liberty
        to terminate your employment immediately.
      </div>
      <h3 className="font-bold mt-6">4. COMPANY'S REGULATIONS/POLICIES </h3>
      <div className="text-justify leading-7">
        You shall abide and be bound by the Company's regulations/policies as
        available on company’s HRMS portal, and the same shall form part of this
        letter of appointment. The Company's regulations/policies may be changed
        / amended at any time at the discretion of the Company and the changed
        Company regulations/policies shall thereupon bind you. You shall also
        carry out and abide by any instruction, policies, 'house rules' and
        'office orders' issued by the Company from time to time.
      </div>
    </PageWrapper>
  );
}
function Page11({ data }) {
  return (
    <PageWrapper>
      <h3 className="font-bold mt-6">
        5. SEPARATION / TERMINATION OF EMPLOYMENT{" "}
      </h3>
      <div className="text-justify leading-7">
        Separation/Termination of employment will be applicable in accordance
        with condition set forth in Separation Policy and Disciplinary,
        Capability and Grievance Management policy. Categories of voluntary
        separation are Resignation, Death, Retirement and End of fixed term.
        Categories of involuntary separation are Non Performance, Sexual
        Harassment, Misconduct and Absenteeism.
      </div>
      <h3 className="font-bold pt-6">6. REPRESENTATION</h3>
      <div className="text-justify leading-7">
        You represent and warrant that you are not bound by or subject to any
        court order, agreement, arrangement or undertaking (including but
        without limitation any non-competition or non-solicitation undertakings)
        or any other disability of any nature which may in any way restrict or
        prohibit you from entering into this letter of appointment or from
        performing your duties and providing services under this agreement of
        employment on the terms and condition contained herein.
      </div>
      <h3 className="font-bold mt-6">7. INTERPRETATION</h3>
      <p className="mt-4 leading-7">
        If any of the provisions of this letter of appointment shall, for any
        reason, be held to be invalid, illegal or unenforceable in any respect,
        such invalidity, illegality or un-enforceability shall not affect any
        other provisions of this letter of appointment, and this letter of
        appointment shall be construed as if such invalid, illegal or
        unenforceable provision has never been contained in this letter of
        appointment. If, moreover, any one or more of the provisions contained
        in this letter of appointment shall for any reason be held to be
        excessively broad as to duration, activity or subject, it shall be
        construed by limiting and reducing it, so as to be enforceable to the
        extent compatible with the applicable law as it shall then appear.
      </p>
    </PageWrapper>
  );
}
function Page12({ data }) {
  return (
    <PageWrapper>
      <h3 className="font-bold mt-6">8. DISPUTES </h3>
      <p className="mt-4 leading-7">
        All disputes or differences whatsoever arising between the Company and
        you out of or relating to the construction, meaning and operation or
        effect of this letter of appointment or the breach thereof shall be
        settled by a senior officer of the Company as nominated by the CHRO and
        the decision made in pursuance thereof shall be binding on you and the
        Company.
      </p>
      <div className="leading-7 text-justify pl-6 pt-6">
        1. Any disputes during or after your employment would first be settled
        amicably between us. Should such a settlement be not possible then the
        same shall be finally settled by arbitration as per the provisions of
        the Arbitration and Conciliation Act, 1996, or any other statutory
        modification or re-enactment thereof. The arbitration shall be conducted
        by a sole arbitrator who shall be an independent and suitably qualified
        third party appointed by the Company. The venue of the arbitration shall
        be Gurgaon, India. The arbitration proceedings shall be conducted in
        English.
      </div>
      <div className="leading-7 text-justify pl-6">
        2. Subject to what is stated above, the courts at New Delhi, India shall
        have the sole jurisdiction in respect of all matters pertaining to this
        appointment.
      </div>
      <div className="leading-7 text-justify pl-6">
        3. This appointment shall be governed and construes exclusively in
        accordance with the laws of India.
      </div>
      <h3 className="font-bold mt-6">9. WAIVER OF BREACH </h3>

      <div className="leading-7 text-justify">
        Any waiver by the Company of a breach of any provision of this letter of
        appointment shall not operate or be construed as a waiver of any
        subsequent breach.
      </div>
    </PageWrapper>
  );
}
function Page13({ data }) {
  return (
    <PageWrapper>
      <p className=" leading-7">
        <b>{data.name}</b>, we thank you for considering Odisha Percel Service
        Limited as your future employer! We have bold objectives:
      </p>
      <p>
        <br />
        1. Create the largest economic value for our customers through our
        fulfillment platform.
        <br /> 2. Become the default choice for any company looking for supply
        chain solutions in India.
        <br /> 3. Focus relentlessly on economy in design and execution and pass
        on the benefits of our frugality to customers
      </p>

      <p className="mt-4 leading-7 text-justify">
        Joining us, shall put you amongst a team that is committed to excellence
        in everything we do. We are a battle-hardened force today, flag-bearers
        for a new generation of fulfillment companies around the world. Our
        clients and their customers trust us to fulfill our service promises and
        to build new paths for commerce, maintaining the highest standards of
        quality, precision and professionalism.
      </p>

      <p className="mt-6">For Odisha Parcel Service</p>

      <p className="mt-24 font-bold">{data.hrName}</p>
      <p>{data.hrDesignation}</p>
      <p className="mt-6 leading-7">
        I accept this letter of appointment on the terms and conditions as
        described herein.
      </p>
      <p className="text-justify mt-6">
        <b>Disclaimer:</b> As part of the green initiative, the Company has
        adopted a paperless policy. Please consider this as the only offer
        letter that will be shared with you. If specifically required for a
        particular purpose, please drop an email to loe@delhivery.com for a hard
        copy. ACKNOWLEDGEMENT:
      </p>
      <div className="mt-6">
        <b>{data.name}</b>
        <div>Date</div>
      </div>
    </PageWrapper>
  );
}
